import { IOrganization, IProfile } from '../../../interfaces/graph-types';
import { OrganizationService } from './../../../services/organization.service';
import { Component, OnInit, Input } from '@angular/core';
import { NotificationService } from '../../../services/notification.service';
import { Subscription } from 'rxjs';

@Component({
  selector: 'notifications',
  template: require('./notifications.component.pug'),
  styles: [require('./notifications.component.css').toString()],
})
export class NotificationsComponent implements OnInit {
  @Input()
  profile: IProfile;

  sub: Subscription;
  counter = 0;
  calls = 0;

  // -------------------------------------------------------------------
  constructor(private notificationService: NotificationService) {}

  // -------------------------------------------------------------------
  ngOnInit() {
    this.sub = this.notificationService.notifications$.subscribe(res => {
      this.counter = res.length;
      this.calls = this.calls + 1;
    });
  }

  // -------------------------------------------------------------------
  ngOnDestroy(): void {
    this.sub.unsubscribe();
  }

  // -------------------------------------------------------------------
  ring() {
    let newClass = {};

    if (this.counter > 0) {
      newClass['has-notifications'] = true;
      newClass['notify'] = this.calls % 2 == 0;
      newClass['notify2'] = this.calls % 2 == 1;
    }
    return newClass;
  }
}
